
/**
 * Classe responsável por realizar a autenticação por OAuth2.
 * 
 * @type
 */
class LoginOAth2 {

    /**
     * Método construtor da classe.
     * 
     * @return {Assinatura}
     */
    constructor(url) {
        this.submitElement = document.getElementById('submit_login_oauth2_form');
        this.form = document.getElementById('login_oauth2_form');
        this.url = url;
        if (this.submitElement !== null) {
            this.submitElement.addEventListener('click', this.login.bind(this));
        }
    }

    /**
     * Método responsável por efetuar o login.
     * 
     * @return {void}
     */
    async login(url) {
        $('#msg-error-login-oauth2').remove();

        try {
            headers = new Headers();
            headers.append("X-Requested-With", "XMLHttpRequest");
            headers.append('Content-Type', 'application/json');
            headers.append('Accept', 'text/plain');
            headers.append('Accept', 'application/json');


            this.submitElement.insertAdjacentHTML('afterEnd', `<span id="loader"><img src="/img/ajax-loader-flower.gif"> Realizando a autenticação.</span>`);

            var result = await fetch(this.url, {
                method: 'POST',
                body: JSON.stringify($('#login_oauth2_form').serializeObject()),
                headers: headers,
                credentials: "same-origin"
            });

            var data = await result.json();

            if (data.success) {
                window.location = "/conta/configure";
            } else {
                $('#loader').remove();
                document.getElementById('fieldset-acesso_submit_outh2').insertAdjacentHTML('afterend', `<div id="msg-error-login-oauth2" class="col col-12-12">
        <div class="msg-error show "><h3>Erro ao tentar efetuar login:</h3><ul><li>${data.msgErro}</li></ul></div>
            </div>`);
            }
        } catch (e) {
            $('#loader').remove();
            alert('Erro na autenticação, contate o suporte');
        }


    }

    /**
     * Método responsável por serializar o form.
     * 
     * @return {void}
     */
    serialize(form) {

        var element = {};

        // Setup our serialized data
        var serialized = [];

        // Loop through each field in the form
        for (var i = 0; i < form.elements.length; i++) {
//            element = {};

            var field = form.elements[i];

            // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
            if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button')
                continue;

            // If a multi-select, get all selections
            if (field.type === 'select-multiple') {
                for (var n = 0; n < field.options.length; n++) {
                    if (!field.options[n].selected || field.options[n].value)
                        continue;

                    element[encodeURIComponent(field.name)] = encodeURIComponent(field.options[n].value);
                    serialized.push(element);
                }
            }

            // Convert field data to a query string
            else if (field.value && ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked)) {
                element[encodeURIComponent(field.name)] = encodeURIComponent(field.value);
                serialized.push(element);
            }
        }

        return element;
    }
}

document.addEventListener("DOMContentLoaded", () => new LoginOAth2());

/**
 * Remove do HTML da modal o pacote de CSS do sistema, para não sobrescrever o CSS da tela de login.
 * Busca pelo nome do arquivo, já que a posição do link no <head> varia conforme o layout.
 *
 * @param {HTMLElement} doc
 * @returns {undefined}
 */
function removeCssSistema(doc) {
    doc.querySelectorAll('link[rel="stylesheet"][href*="/build/css/stylesheets-sistema-"]').forEach(function (link) {
        link.remove();
    });
}

function openModalOAuth2() {
    $.get('/padrao/conta/loginoauth2/', {
    }, function (data) {
        var doc = document.createElement('html');
        doc.style = 'overflow: hidden;'
        doc.innerHTML = data;
        removeCssSistema(doc);
        abreBlockUI(doc, 'Login OAuth2 Inovadora');

        new LoginOAth2('/padrao/conta/loginoauth2/');
    });
}

function openModalMagda() {
    $.get('/padrao/conta/logininovadoramagda/', {
    }, function (data) {
        var doc = document.createElement('html');
        doc.style = 'overflow: hidden;'
        doc.innerHTML = data;
        removeCssSistema(doc);
        abreBlockUI(doc, 'Login Magda Inovadora');

        new LoginOAth2('/padrao/conta/logininovadoramagda/');
    });
}


/**
 * Função para abrir blockUI na lista de espera
 * @param {type} data
 * @param {type} title
 * @returns {undefined}
 */
function abreBlockUI(data, title) {
    if (data !== null && $.trim(data) !== '') {
        global._babelPolyfill = null;
        $('#black').show();
        $.blockUI({
            theme: true,
            draggable: true,
            bindEvents: false,
            title: title + '<a href=\"javascript:;\"  class=\"btn-i-nao right fechar_msg\"></a>',
            message: data,
            themedCSS: {
                width: '30%',
                left: '35%',
                position: 'absolute',
                top: '10%'
            }
        });
        $('.seleciona_filtro').css('cursor', 'pointer');
        $('.fechar_msg').click(function () {
            $.unblockUI();
            $('#black').hide();
        });
    }
}
